const lockZoneData = [
    {
        zone: 0,
        min: 6,
        max: 31
    },
    {
        zone: 1,
        min: 32,
        max: 55
    },
    {
        zone: 2,
        min: 56,
        max: 134
    },
    {
        zone: 3,
        min: 135,
        max: 182
    },
    {
        zone: 4,
        min: 183,
        max: 211
    },
    {
        zone: 5,
        min: 212,
        max: 235
    },
    {
        zone: 6,
        min: 236,
        max: 313
    },
    {
        zone: 7,
        min:314,
        max: 361
    } 
]

export default lockZoneData